import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from './Tooltip';

const CustomCheckbox = ({
	label,
	checked,
	setChecked,
	name = null,
	// onChange = null,
	type,
	disabled = false,
	tooltip = null
}) => {
	const getSize = () => {
		if (!type) {
			return '16px';
		} else {
			if (type === 1) {
				return '16px';
			} else if (type === 2) {
				return '24px';
			}
		}
	};

	return (
		<div
			onClick={() => !disabled && setChecked(!checked)}
			className="form-check-container"
			style={{
				marginLeft: '0',
				cursor: disabled ? 'default' : 'pointer',
				position: 'relative'
			}}
			data-testid={name ? name : 'custom-checkbox'}
		>
			<div
				style={{ width: getSize(), height: getSize(), opacity: disabled ? 0.5 : 1 }}
				className={
					'custom-checkbox ' +
					(checked
						? type === 1 || !type
							? 'custom-checkbox-checked'
							: 'custom-checkbox-checked-medium'
						: 'custom-checkbox')
				}
			/>
			<label
				style={{
					marginBottom: 0,
					marginLeft: '10px',
					fontWeight: 400,
					cursor: disabled ? 'default' : 'pointer',
					opacity: disabled ? 0.5 : 1
				}}
				className="checkbox-label"
			>
				{label}
			</label>
			{name ? (
				<input
					name={name}
					type="checkbox"
					style={{ display: 'none' }}
					checked={checked}
					readOnly={true}
					disabled={disabled}
					data-testid={name}
				/>
			) : null}
			{tooltip ? <Tooltip content={tooltip} /> : null}
		</div>
	);
};

CustomCheckbox.propTypes = {
	label: PropTypes.string,
	checked: PropTypes.bool,
	setChecked: PropTypes.func,
	name: PropTypes.string,
	onChange: PropTypes.func,
	type: PropTypes.number,
	disabled: PropTypes.bool,
	tooltip: PropTypes.string
};

export default CustomCheckbox;
